import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';
import { SelectOption } from '@bcl/design-system';
import { SnackbarService } from '@bcl/design-system';
import { Platform } from '@ionic/angular';
import { VisitService } from 'src/app/services/visit.service';

@Component({
  selector: 'app-visit-detail-report-to-office',
  templateUrl: './visit-detail-report-to-office.component.html',
  styleUrls: ['./visit-detail-report-to-office.component.scss'],
})
export class VisitDetailReportToOfficeComponent
  extends BaseAccordionComponent
  implements OnInit, OnChanges
{
  @Input() visit: any;
  @Input() officeMemoPersons: SelectOption[] = [];
  @Input() isEditingDisabled = false;

  @Output() saveSummaryField = new EventEmitter<void>();
  public form: FormGroup;
  public initialMemo: string | null = null;

  constructor(
    private fb: FormBuilder,
    private visitService: VisitService,
    private snackbarService: SnackbarService,
    public platform: Platform,
    accordionService: AccordionService
  ) {
    super(accordionService);
    this.form = this.fb.group({
      memoOffice: [null, [Validators.required]],
      memoOfficePerson: [null, Validators.required],
    });
  }

  // Computed property to check if form should be disabled
  get isFormDisabled(): boolean {
    return this.isEditingDisabled;
  }

  ngOnInit() {
    super.ngOnInit();
    this.form.patchValue({
      memoOffice: this.visit.memoOffice ?? null,
      memoOfficePerson: this.visit.memoOfficePerson?.toString() ?? null,
    });
    this.initialMemo = this.visit.memoOffice ?? null;

    // Disable form if visit is completed and not reopened
    if (this.isFormDisabled) {
      this.form.disable();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Watch for changes to isEditingDisabled input
    if (changes.isEditingDisabled) {
      const currentValue = changes.isEditingDisabled.currentValue;
      const previousValue = changes.isEditingDisabled.previousValue;

      // Only update if the value actually changed
      if (currentValue !== previousValue) {
        this.updateFormDisabledState();
      }
    }
  }
  public setMemo(desc: string) {
    this.form.get('reportToOffice')?.setValue(desc);
    this.form.markAsDirty();
  }
  public saveMemo() {
    const formValue = this.form.value;

    this.visitService
      .updateOfficeMemo(
        this.visit.visitId,
        formValue.memoOffice,
        formValue.memoOfficePerson
      )
      .subscribe({
        next: () => {
          this.visit.memoOffice = formValue.memoOffice;
          this.visit.memoOfficePerson = formValue.memoOfficePerson;
          this.snackbarService.open(
            'green',
            'AREA.DETAILS.REPORT_TO_OFFICE.MESSAGES.REPORT_SAVED'
          );
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_PLEASE_TRY_AGAIN_LATER'
          );
        },
      });
  }
  private updateFormDisabledState(): void {
    if (this.isFormDisabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }
}
